import { render, staticRenderFns } from "./modalTemplate.vue?vue&type=template&id=bc0f8d74"
import script from "./modalTemplate.vue?vue&type=script&lang=js"
export * from "./modalTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports